
  <div class="change-address single-card-column">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon margin-bottom mb8">
          <svg-caution-color-svg></svg-caution-color-svg>
        </div>  
        <h1 class="title-copy">{{ 'PROFILE_EMAIL_CONF_ONE' | translate }}</h1> 
        <div >
          {{ 'PROFILE_EMAIL_CONF_TWO' | translate }} 
        </div>
      </div>
    </div>
    <div class="row text-center margin-vertical mv24">
      <div class="col">
        <div class="font-size xsmall-font">
          {{ 'PROFILE_EMAIL_CONF_THREE' | translate }}
        </div>
        <div class="font-size medium-font newEmailEdit">
          <strong>{{ newEmail }}</strong> 
          <a 
          [routerLink]="['/profile','edit-email']"
          class="inline-svg margin-left ml16" > 
            <svg-edit-icon-svg></svg-edit-icon-svg>
          </a>
        </div>
      </div>
    </div>
    <div class="row margin-bottom mb24 text-center">
      <div class="col">
        <mapfre-button
          [ngClass]="{'custom_loader':loader}"
          [disabledValue]="!loader" 
          additionalClasses="primary basic large-btn no-margin h48 w280"
          (click)="confirmNewEmail()"
          >{{ 'PROFILE_EMAIL_CONF_FOUR' | translate }}
        </mapfre-button>
      </div>
    </div>
    <div class="row text-center margin-bottom mb16">
      <div class="col">
        <mapfre-button 
          additionalClasses="link-button small-btn blue-link" 
          (click)="cancel()"
        >  {{ 'CANCEL' | translate }}
        </mapfre-button>
      </div>
    </div>
  </div>

